import { BiCalendarPlus } from "react-icons/bi"; 
import { TbFileCertificate } from "react-icons/tb"; 
import { BiCamera } from "react-icons/bi"; 
import { CgImport } from "react-icons/cg"; 
import { BiRefresh } from "react-icons/bi"; 
import { BiLinkExternal } from "react-icons/bi";
import { CgFileDocument } from "react-icons/cg";
import { BiPrinter } from "react-icons/bi";
import React, { useRef } from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxChooser from '../../cx/CxChooser';
import CxSearcher from '../../cx/CxSearcher';
import CxDate from '../../cx/CxDate';
import CxStatic from '../../cx/CxStatic';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxAccordion from '../../cx/CxAccordion';
import CxTable from '../../cx/CxTable';
import CxDialog from '../../cx/CxDialog';
import CxDlgTable from '../../cx/CxDlgTable';
import CxDlgDoc from '../../cx/CxDlgDoc';
import CxDlgUpgrade from '../../cx/CxDlgUpgrade';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxEdition from '../../fx/FxEdition';
import * as FxFetch from '../../fx/FxFetch';
import * as FxFile from '../../fx/FxFile';
import * as FxDat from '../../fx/FxDat';
import * as FxInet from '../../fx/FxInet';
import * as FxStr from '../../fx/FxStr';
import * as FxRegion from '../../fx/FxRegion';
import * as FxCertificate from '../../fx/FxCertificate';
import GxForm from '../../gx/GxForm';
import GxPrint from '../../gx/GxPrint';
import GxDlgSelectClient from '../../gx/GxDlgSelectClient';
import { clearStore, getStoreValue, getStoreValueBo, StoreClient, StoreRxAuto, StoreAnimalWeight, 
  StoreGrooming, StoreBoarding, StoreCns, StoreVacc, StoreImage, StoreCalendarView, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxDlgAlert from '../../cx/CxDlgAlert';
import CxSnackbar from '../../cx/CxSnackbar';
import CxState from '../../cx/CxState';
import CxCombo from '../../cx/CxCombo';
import { useWindowSize } from '../../hx/useWindowSize';
import * as MxAnimalRxAutoFormH1 from './MxAnimalRxAutoFormH1';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import MxTypeOTF from '../common/otf/MxTypeOTF';
import CxButtonShowMore from '../../cx/CxButtonShowMore';
import CxIconButtonMenu from '../../cx/CxIconButtonMenu';
import GxPrintLong from '../../gx/GxPrintLong';


const MxAnimalForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo, navStack, }] = useNav();
  const size = useWindowSize();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const SEC = 1000; // un segundo en milisegundos
  const timer = React.useRef(null);

  let r_dlg_doc = React.useRef(null);
  let r_dlg_upgrade = React.useRef(null);
  let rf_owner = React.useRef(null);
  let rf_inClient = React.useRef(null);
  let rf_txAnimal = React.useRef(null);

  let r_print = React.useRef(null);
  let r_dlg_select_client = React.useRef(null);

  const [certificate, setCertificate] = React.useState({});

  const [wasActive, setWasActive] = React.useState(true);
  
  const r_snack_ask_save = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  const r_snack_op_failed = React.useRef(null);
  const r_snack_error = React.useRef(null);
  const r_snack_required = React.useRef(null);

  const r_dlg_alert = React.useRef(null);
  const r_dlgtable_rxs_invoice = React.useRef(null);

  const r_dlg_new_species = React.useRef(null);
  const r_dlg_new_breed = React.useRef(null);
  const r_dlg_new_coat = React.useRef(null);

  const [dlgPrint, setDlgPrint] = React.useState(false);
  const [dlgRxsInvoice, setDlgRxsInvoice] = React.useState(false);

  const rf_print_preview = React.useRef(null);
  const rf_print_cert_sign = React.useRef(null);
  const rf_print_from = React.useRef(null);
  const rf_print_to = React.useRef(null);

  const r_gx_print_long = React.useRef(null);

  const r_form = React.useRef(null);
  const r_table_vaccs = React.useRef(null);
  const r_table_cnss = React.useRef(null);
  const r_table_rxs = React.useRef(null);
  const r_table_groo = React.useRef(null);
  const r_table_brdg = React.useRef(null);
  const r_table_images = React.useRef(null);
  const r_table_multimedia = React.useRef(null);
  const r_table_weight = React.useRef(null);
  const r_accordion_vaccs = React.useRef(null);
  const r_accordion_cnss = React.useRef(null);
  const r_accordion_rxs = React.useRef(null);
  const r_accordion_groo = React.useRef(null);
  const r_accordion_brdg = React.useRef(null);
  const r_accordion_images = React.useRef(null);
  const r_accordion_multimedia = React.useRef(null);
  const r_accordion_weight = React.useRef(null);

  const rf_txNumber = React.useRef(null);
  const rf_dtFrom = React.useRef(null);
  const rf_dtTo = React.useRef(null);
  const rf_txTypeAnimalSpecies = React.useRef(null);
  const rf_txTypeAnimalBreed = React.useRef(null);
  const rf_txTypeAnimalCoat = React.useRef(null);
  const rf_txTypeAnimalCondition = React.useRef(null);
  const rf_txNumberAnimals = React.useRef(null);
  const rf_txTypeRate = React.useRef(null);
  const rf_txEmployee = React.useRef(null);

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeAnimalWeight, setStoreAnimalWeight] = useSessionStorage('StoreAnimalWeight', StoreAnimalWeight);
  const [storeVacc, setStoreVacc] = useSessionStorage('StoreVacc', StoreVacc);
  const [storeCns, setStoreCns] = useSessionStorage('StoreCns', StoreCns);
  const [storeRxAuto, setStoreRxAuto] = useSessionStorage('StoreRxAuto', StoreRxAuto);
  const [storeGrooming, setStoreGrooming] = useSessionStorage('StoreGrooming', StoreGrooming);
  const [storeBoarding, setStoreBoarding] = useSessionStorage('StoreBoarding', StoreBoarding);
  const [storeCalendarView, setStoreCalendarView] = useSessionStorage('StoreCalendarView', StoreCalendarView);
  const [storeImage, ] = useSessionStorage('StoreImage', StoreImage);
  const animalAccordionId = storeClient.inAnimal || `new-${storeClient.inClient || 'client'}`;
  const getAnimalAccordionStorageKey = (section) => `MxAnimalForm.${animalAccordionId}.accordion.${section}`;


  React.useEffect(() => {
    FxLog.infox('MxAnimalForm.useEffect', '...', );
    
    if (!navStack().includes('activity-vett-v-list') 
      && !navStack().includes('activity-vett-c-list') 
      && !navStack().includes('activity-vett-r-list') 
      && !navStack().includes('activity-vett-g-list')
      && !navStack().includes('activity-vett-b-list')
    ) {
      FxLog.infox('MxAnimalForm.useEffect', '...cleaning store', );
      clearStore('StoreAnimalWeight', storeAnimalWeight);
      clearStore('StoreVacc', storeVacc);
      clearStore('StoreCns', storeCns);
      clearStore('StoreRxAuto', storeRxAuto);
      clearStore('StoreGrooming', storeGrooming);
      clearStore('StoreBoarding', storeBoarding);
    }

    timer.current = setInterval(() => {
      const currentTimerId = timer.current; // ← captura el ID exacto de este interval
      
      if (FxInet.isOnline() && r_table_multimedia.current) { // ← null-check
        Promise.all([r_table_multimedia.current.redisplay()])
          .then((result) => {
            FxLog.infox('MxAnimalForm.useEffect', '...result[0]:', result[0]);
            if (result[0] === 'FETCH-ERROR: NULL') {
              clearInterval(currentTimerId); // ← usa la variable local, no el ref
              timer.current = null;
            }
            if (r_accordion_multimedia.current) {
              r_accordion_multimedia.current.setFontWeight(
                r_table_multimedia.current?.isEmpty() ? 'normal' : 'bold'
              );
            }
          })
          .catch((e) => {
            // Si el componente se desmontó y redisplay() lanzó, paramos el timer igualmente
            FxLog.errorx('MxAnimalForm timer', e);
            clearInterval(currentTimerId);
            timer.current = null;
          });
      }
    }, 10 * SEC);
    
    return () => {
      FxLog.infox("MxAnimalForm.useEffect", "cleaning up timer...");
      clearInterval(timer.current);
    }
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data === null) { //nuevo registro
      rf_dtFrom.current.setValToday();
      rf_txNumberAnimals.current.setVal('1');
    } else {
      rf_txTypeAnimalBreed.current.setFilter(`t_animal_breed.itAnimalSpecies='${data[0].itAnimalSpecies}'`);
      rf_txAnimal.current.setLocked(true);
      localStorage.setItem('MxClientForm.last_client', `${storeClient.inClient}`);
      localStorage.setItem('MxAnimalForm.last_animal', `${storeClient.inAnimal}`);

      setWasActive(Boolean(rf_dtTo.current.isEmpty()));

      const _loadTables = async () => {
        await Promise.all([
          r_table_weight.current?.refresh(),
          r_table_vaccs.current?.refresh(),
          r_table_cnss.current?.refresh(),
          r_table_rxs.current?.refresh(),
          r_table_groo.current?.refresh(),
          r_table_brdg.current?.refresh(),
          r_table_images.current?.refresh(),
          r_table_multimedia.current?.refresh(),
        ]);
        updateAccordions();
      };
      _loadTables();

    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theValue.startsWith("rv_")) {
      // errores al guardar
      if (lastSaveRv.theValue.startsWith("rv_exists_chip")) {
        r_snack_error.current.setValAndOpen(trans('msg.existing_x', 'field.chip'));
      }
      if (lastSaveRv.theValue.startsWith("rv_exists_passport")) {
        r_snack_error.current.setValAndOpen(trans('msg.existing_x', 'field.passport'));
      }
    } else {
      storeClient.inAnimal = lastSaveRv.theValue;
      storeClient.txAnimal = rf_txAnimal.current.getVal();
      Promise.all([setStoreClient(storeClient)]).then((result) => {
        localStorage.setItem('MxClientForm.last_client', `${storeClient.inClient}`);
        localStorage.setItem('MxAnimalForm.last_animal', `${storeClient.inAnimal}`);
        if (lastSaveRv.txNumber) {
          rf_txNumber.current.setVal(lastSaveRv.txNumber);
        }
        r_form.current.resetChanged();
        forceUIUpdate();
      });
      if (!rf_dtTo.current.isEmpty() && wasActive) {
        FxLog.infox('MxAnimalForm.formSave', '...EL PACIENTE ACABA DE SER DADO DE BAJA');
        setWasActive(!wasActive);
        // 2026-05-21 - daq: log de baja animal
        FxLog.logUserToDb('U', 
          `${trans('field.animal')}: ${trans('field.inactive')}->${rf_dtTo.current.getVal()}: ${storeClient.txAnimal} - ${storeClient.txClient}`, 
          trans('field.animals'), 
          storeClient.inAnimal
        )
      }
    }
  }
  const formDelete = async (rv) => {
    localStorage.removeItem('MxAnimalForm.last_animal');
  }

  const openFormVacc = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeVacc.inVacc = null;
      } else {
        storeVacc.inVacc = row.original.inVacc;
        storeVacc.boComm = row.original.hasComm;
      }
      setStoreVacc(storeVacc);
      navTo("animal-vacc-form");
    }
  }

  const openCalendar = () => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      storeCalendarView.strOrigin = 'from_animal';
      setStoreCalendarView(storeCalendarView);
      setTimeout(() => { navTo("calendar-view") }, 10);
    }
  }

  const openFormCns = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (op.split(':')[0]==='c') {
        storeCns.inCns = null;
        setStoreCns(storeCns);
        if (op.split(':')[1]==='G') {
          navTo("animal-cns-grl-form");
        }
        if (op.split(':')[1]==='H') {
          if (!FxEdition.isInEdition('CLI_hos')) {
            r_dlg_upgrade.current.setOpen(true);
          } else {
            navTo("animal-cns-hos-form");
          }
        }

      } else {
        storeCns.inCns = row.original.inCns;
        setStoreCns(storeCns);
        if (row.original.txType === 'G') navTo("animal-cns-grl-form");
        if (row.original.txType === 'H') navTo("animal-cns-hos-form");
      }
    }
  }

  const openCnsInNewTab = (row) => {
    const form = row.txType === 'H' ? 'animal-cns-hos-form' : 'animal-cns-grl-form';
    storeCns.inCns = row.inCns;
    setStoreCns(storeCns);

    if (getStoreValueBo('StoreSession', 'boShowTabs')) {
      const tabLabel = `Consulta - ${FxTable.cellToLocalDateTime(row.dtFrom)}`;
      window.__mxMain_openTabWithNavigation(form, tabLabel, false, String(row.inCns));
    } else {
      navTo(form);
    }
  }

  const openFormRxs = async (op, row) => {
    storeRxAuto.boFirstRender = true;
    storeRxAuto.boDataChanged = '0';
    storeRxAuto.inClient = storeClient.inClient;
    storeRxAuto.inAnimal = storeClient.inAnimal;
    storeRxAuto.txClient = storeClient.txClient;
    storeRxAuto.txAnimal = storeClient.txAnimal;

    if (op.split(':')[0]==='c') {
      storeRxAuto.boAuto = Boolean(op.split(':')[1] === 'A');
      //storeRxAuto.inRxAuto = null;
      storeRxAuto.txRxAuto = null;
      storeRxAuto.itSeriesRx = null;
      storeRxAuto.inInvoice = null;
      Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
        if (op.split(':')[1] === 'M') {
          navTo("animal-rx-auto-form");
        }
        if (op.split(':')[1] === 'A') {
          setDlgRxsInvoice(true);
        }
      });
      
    } else {
      FxLog.infox('MxAnimalForm.openFormRxs', '...row.original:', row.original);
      storeRxAuto.boAuto = Boolean(row.original.inInvoice);
      //storeRxAuto.inRxAuto = row.original.inRxAuto;
      storeRxAuto.txRxAuto = row.original.txRxAuto;
      storeRxAuto.itSeriesRx = row.original.itSeriesRx;
      FxLog.infox('MxAnimalForm.openFormRxs', '...storeRxAuto:', storeRxAuto);
      Promise.all([MxAnimalRxAutoFormH1.load(storeRxAuto)]).then((result) => {
        setStoreRxAuto(storeRxAuto);
        navTo("animal-rx-auto-form");
      });
    }
  }

  const openFormRxsNewAuto = async (row) => {
    setDlgRxsInvoice(false);

    if (row) {
      storeRxAuto.inInvoice = row.original.inInvoice;
      Promise.all([MxAnimalRxAutoFormH1.loadFromInvoice(storeRxAuto)]).then((result) => {
        Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
          navTo("animal-rx-auto-form");
        });
      });
    }
  }

  const openFormGroo = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeGrooming.inGrooming = null;
      } else {
        storeGrooming.inGrooming = row.original.inGrooming;
      }
      setStoreGrooming(storeGrooming);
      navTo("animal-groo-form");
    }
  }

  const openFormBrdg = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeBoarding.inBoarding = null;
      } else {
        storeBoarding.inBoarding = row.original.inBoarding;
      }
      setStoreBoarding(storeBoarding);
      navTo("animal-brdg-form");
    }
  }

  const openFormImage = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      clearStore('StoreImage', storeImage);
      if (row === null) {
        storeClient.inImage = null;
      } else {
        storeClient.inImage = row.original.inImage;
      }
      setStoreClient(storeClient);
      navTo("client-image-form");
    }
  }

  const openFormMultimedia = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeClient.inMultimedia = null;
      } else {
        storeClient.inMultimedia = row.original.inMultimedia;
      }
      setStoreClient(storeClient);
      navTo("client-multimedia-form");
    }
  }

  const openFormWeight = async (op, row) => {
    if (!storeClient.inAnimal) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeAnimalWeight.inAnimalWeight = null;
      } else {
        storeAnimalWeight.inAnimalWeight = row.original.inAnimalWeight;
      }
      setStoreAnimalWeight(storeAnimalWeight);
      navTo("animal-weight-form");
    }
  }

  const speciesChanged = async (row) => {
    if (row !== null) {
      // inyecta filtros en el selector paciente
      let itAnimalSpecies = row.original.itAnimalSpecies;
      rf_txTypeAnimalBreed.current.setFilter(`t_animal_breed.itAnimalSpecies='${itAnimalSpecies}'`);
      rf_txTypeAnimalBreed.current.clear();
    }
  }

  const clearBreed = () => {
    rf_txTypeAnimalBreed.current.clear();
  }

  const canOpenDlgBreed = () => {
    return rf_txTypeAnimalSpecies.current.getKey() !== '';
  }

  const doPrintX = async (option) => {
    let dtFrom = rf_print_from.current.getVal();
    let dtTo = rf_print_to.current.getVal();
    let boPreview = rf_print_preview.current.isChecked();
    let boCertSign = rf_print_cert_sign.current.isChecked();
    let inEmployee = storeClient.inEmployee;
    let inClient = storeClient.inClient;
    let inAnimal = storeClient.inAnimal;
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inClient'] = inClient;
    filter['inAnimal'] = inAnimal;
    filter['dtFrom'] = dtFrom;
    filter['dtTo'] = dtTo;
    let record = {};
    localStorage.setItem('MxAnimalForm.boPreview', boPreview ? '1' : '0');
    r_print.current.setScale(1.5);
    r_print.current.setUrl('animals/report/history');
    r_print.current.setPreview(boPreview);
    r_print.current.setCertificate(boCertSign ? certificate : {});
    //----------------
    setDlgPrint(false);
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
      r_print.current.setInEmployee(inEmployee),
      r_print.current.setInClient(inClient),
      r_print.current.setInAnimal(inAnimal),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  const getCnsOptions = () => {
    return [
      { id: 'G', text: trans('field.cns_grl') },
      { id: 'H', text: trans('field.cns_hos') },
    ];
  }

  const updateAccordions = () => {
    if (isApp('vett')) {
      r_accordion_weight.current.setFontWeight(r_table_weight.current.isEmpty() ? 'normal' : 'bold');
      r_accordion_vaccs.current.setFontWeight(r_table_vaccs.current.isEmpty() ? 'normal' : 'bold');
      r_accordion_cnss.current.setFontWeight(r_table_cnss.current.isEmpty() ? 'normal' : 'bold');
      r_accordion_rxs.current.setFontWeight(r_table_rxs.current.isEmpty() ? 'normal' : 'bold');
      r_accordion_brdg.current.setFontWeight(r_table_brdg.current.isEmpty() ? 'normal' : 'bold');
    }
    r_accordion_groo.current.setFontWeight(r_table_groo.current.isEmpty() ? 'normal' : 'bold');
    r_accordion_images.current.setFontWeight(r_table_images.current.isEmpty() ? 'normal' : 'bold');
    r_accordion_multimedia.current.setFontWeight(r_table_multimedia.current.isEmpty() ? 'normal' : 'bold');

    FxLog.infox('MxAnimalForm.updateAccordions', '...navStack():', navStack());
    if (navStack().includes('activity-vett-v-list')) { // si viene de actividades-vacunas
      r_table_vaccs.current.setDisabled(true);
      r_table_vaccs.current.setDisabledAlert(trans('msg.loop_restriction_0', 'field.vacc'));
    }
    if (navStack().includes('activity-vett-c-list')) { // si viene de actividades-consultas
      r_table_cnss.current.setDisabled(true);
      r_table_cnss.current.setDisabledAlert(trans('msg.loop_restriction_0', 'field.cns'));
    }
    if (navStack().includes('activity-vett-r-list')) { // si viene de actividades-recetas
      r_table_rxs.current.setDisabled(true);
      r_table_rxs.current.setDisabledAlert(trans('msg.loop_restriction_0', 'field.rx'));
    }
    if (navStack().includes('activity-vett-g-list')) { // si viene de actividades-peluquería
      r_table_groo.current.setDisabled(true);
      r_table_groo.current.setDisabledAlert(trans('msg.loop_restriction_0', 'field.groo_session'));
    }
    if (navStack().includes('activity-vett-b-list')) { // si viene de actividades-residencia
      r_table_brdg.current.setDisabled(true);
      r_table_brdg.current.setDisabledAlert(trans('msg.loop_restriction_1', 'field.brdg_admission'));
    }
    forceUIUpdate();
  }

  const integrationImports = async (option) => {
    let data = { 
      client: { inClient: storeClient.inClient, txClient: storeClient.txClient },
      animal: { inAnimal: storeClient.inAnimal, txAnimal: storeClient.txAnimal },
    };
    if (option === 'intech') {
      let fileName = `ibs_localhub_intech_${FxDat.timestamp()}.json`;
      FxFile.saveJson(fileName, data);
    };
    if (option.startsWith('scil')) {
      if (rf_txTypeAnimalSpecies.current.isEmpty()) { r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.species')); return; }
      if (r_form.current.wasChanged()) {
        r_snack_ask_save.current.setOpen(true);
      } else {
        let fileName = `ibs_localhub_scil_${FxDat.timestamp()}.json`;
        data = {...data, ...{device: { name: option.split('-')[1] }}};
        FxFile.saveJson(fileName, data);
      }
    };
  }

  const doPrintVaccCertAll = async () => {
    let inEmployee = storeClient.inEmployee;
    let inClient = storeClient.inClient;
    let inAnimal = storeClient.inAnimal;
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inClient'] = inClient;
    filter['inAnimal'] = inAnimal;
    let record = {};
    r_print.current.setScale(1.5);
    r_print.current.setUrl('animals/report/certificate_all');
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
      r_print.current.setInEmployee(inEmployee),
      r_print.current.setInClient(inClient),
      r_print.current.setInAnimal(inAnimal),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  const doPrintCard = () => {
    let inClient = storeClient.inClient;
    let inAnimal = storeClient.inAnimal;
    let filter = {};
    let record = {};
    r_gx_print_long.current.setUrlBuild('animals/report/card_build');
    r_gx_print_long.current.setUrlGet('animals/report/card_get');
    //----------------
    Promise.all([
      r_gx_print_long.current.setFilter(filter),
      r_gx_print_long.current.setRecord(record),
      r_gx_print_long.current.setInClient(inClient),
      r_gx_print_long.current.setInAnimal(inAnimal)
    ]).then((result) => {
      r_gx_print_long.current.doPrint();
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.patient')}`}
        xref={r_form}
        url="animals"
        filterIdField='inAnimal'
        filterIdValue={storeClient.inAnimal}
        onFormLoad={formLoad}
        onFormSave={formSave}
        onFormDelete={formDelete}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón de impresión de historial */}
            {storeClient.inAnimal
              && <CxIconButtonNew icon={<BiPrinter fontSize="24px" />} classType="ibs_iconbutton_toolbar"
                tooltip={trans('field.print_x', 'field.history')}
                onClick={() => {
                  if (r_table_weight.current.isEmpty() && r_table_vaccs.current.isEmpty() && r_table_cnss.current.isEmpty()) {
                    r_snack_error.current.setValAndOpen(trans('msg.missing_information'));
                  } else {
                    setDlgPrint(true);
                  }
                }}
            />}

            {/* botón de documentos */}
            {storeClient.inAnimal
              && <CxIconButtonNew icon={<CgFileDocument fontSize="24px" />} classType="ibs_iconbutton_toolbar"
                tooltip={trans('field.docs')}
                onClick={() => r_dlg_doc.current.setDlgDocs(true)}
            />}

            {/* botón de impresión de certificados de vacunación */}
            {storeClient.inAnimal && (r_table_vaccs.current && !r_table_vaccs.current.isEmpty()) && isApp('vett')
              && <CxIconButtonNew icon={<TbFileCertificate fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={() => doPrintVaccCertAll()} tooltip={trans('field.vaccs_certificate')} 
            />}

            {/* botón de importación de integraciones */}
            {size.isLarge && storeClient.inAnimal && isApp('vett') 
              && <CxIconButtonMenu icon={<CgImport fontSize="24px" />} tooltip={trans('field.import_x', 'field.result')} onSelection={integrationImports} className="ibs_iconbutton_toolbar" width='150px'
                options={[
                  { id: 'intech', text: 'Intech', },
                  /* { id: 'scil-SMT100', text: 'Scil Element RC', }, */
                  /* { id: 'scil-HT5', text: 'Scil Element HT5', }, */
                ]}
            />}

            {/* botón de foto */}
            {storeClient.inAnimal
              && <CxIconButtonNew icon={<BiCamera fontSize="24px" style={{ marginTop: '2px' }} />} classType="ibs_iconbutton_toolbar"
                tooltip={trans('field.photo')}
                onClick={() => navTo('animal-photo-form')}
            />}

            {/* botón de calendario */}
            {storeClient.inAnimal
              && <CxIconButtonNew icon={<BiCalendarPlus fontSize="24px" style={{ marginTop: '0px' }} />} classType="ibs_iconbutton_toolbar"
                tooltip={trans('field.next_x', 'field.appointment')}
                onClick={openCalendar}
            />}

            {/* enlaces */}
            {storeClient.inAnimal && 
              <CxIconButtonMenu className="ibs_iconbutton_toolbar" onSelection={(option) => {
                switch (option) {
                  case 'sales': navTo('sls-doc-list', { inClient: storeClient.inClient, txClient: storeClient.txClient, inAnimal: storeClient.inAnimal, txAnimal: storeClient.txAnimal }); break;
                  case 'history': navTo('history-filter', { inClient: storeClient.inClient, txClient: storeClient.txClient, inAnimal: storeClient.inAnimal, txAnimal: storeClient.txAnimal }); break;
                  case 'card': doPrintCard(); break;
                  default: break;
                }
              }}
                options={[
                  { id: 'sales', text: trans('field.sales') },
                  { id: 'history', text: trans('field.history'), },
                  { id: 'card', text: trans('field.card'), },
                ]}
                /* tooltip={`${trans('field.show_more')}`} */
              />
            }

          </div>
        }
      >
        <CxHidden xref={rf_inClient} dbfield="n_animal.inClient" value={storeClient.inClient} />

        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CxStatic xref={rf_owner} label={`${storeClient.txClient}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />
            <CxIconButtonNew
              icon={<BiRefresh fontSize={20} />}
              style={{ color: 'var(--ibs_color_blue)', marginLeft: '4px' }}
              onClick={() => r_dlg_select_client.current.setOpen(true)}
              tooltip={trans('field.change_x', 'field.owner')}
            />
          </div>
        </div>
        
        <CxInput xref={rf_txAnimal} label={trans('field.patient')} dbfield="n_animal.txAnimal" capitalize normalizeSpaces maxLength={50} required />

        <CxSearcher xref={rf_txTypeAnimalSpecies} label={trans('field.species')}
          dbfield="t_animal_species.txTypeAnimalSpecies" dbfieldkey="n_animal.itAnimalSpecies"
          tooltip={trans('field.species')}
          onSelection={speciesChanged}
          onClear={clearBreed}
          onButtonAddOTF={() => {
            rf_txTypeAnimalSpecies.current.setDlg(false);
            r_dlg_new_species.current.setDlg(true);
          }}
          url="sett/animal_species"
          col_id="itAnimalSpecies"
          col_tx="txTypeAnimalSpecies"
          columns={[
            { id: "0", Header: "ID", accessor: "itAnimalSpecies", show: false },
            { id: "1", Header: trans('field.species'), accessor: row => rf_txTypeAnimalSpecies.current.getTable().highlightText(row["txTypeAnimalSpecies"]), width: '100%' },
          ]}
        />

        <CxSearcher xref={rf_txTypeAnimalBreed} label={trans('field.breed')}
          dbfield="t_animal_breed.txTypeAnimalBreed" dbfieldkey="n_animal.itAnimalBreed"
          tooltip={trans('field.breed')}
          canOpenDialog={canOpenDlgBreed}
          onButtonAddOTF={() => {
            rf_txTypeAnimalBreed.current.setDlg(false);
            r_dlg_new_breed.current.setDlg(true);
          }}
          url="sett/animal_breed"
          col_id="itAnimalBreed"
          col_tx="txTypeAnimalBreed"
          columns={[
            { id: "0", Header: "ID", accessor: "itAnimalBreed", show: false },
            { id: "1", Header: trans('field.breed'), accessor: row => rf_txTypeAnimalBreed.current.getTable().highlightText(row["txTypeAnimalBreed"]), width: '100%' },
          ]}
        />

        <CxSearcher xref={rf_txTypeAnimalCoat} label={trans('field.coat')}
          dbfield="t_animal_coat.txTypeAnimalCoat" dbfieldkey="n_animal.itAnimalCoat"
          canOpenDialog={canOpenDlgBreed}
          onButtonAddOTF={() => {
            rf_txTypeAnimalCoat.current.setDlg(false);
            r_dlg_new_coat.current.setDlg(true);
          }}
          url="sett/animal_coat"
          col_id="itAnimalCoat"
          col_tx="txTypeAnimalCoat"
          columns={[
            { id: "0", Header: "ID", accessor: "itAnimalCoat", show: false },
            { id: "1", Header: trans('field.coat'), accessor: row => rf_txTypeAnimalCoat.current.getTable().highlightText(row["txTypeAnimalCoat"]), width: '100%' },
          ]}
        />

        <CxDate xref={useRef(null)} label={trans('field.birth')} dbfield="n_animal.dtBirth" showAge />

        <CxCombo xref={useRef(null)}
          label={`${trans('field.gender')}`}
          dbfield='n_animal.boGender'
          list={[
            { id: '0', type: trans('field.animal_female') },
            { id: '1', type: trans('field.animal_male') },
            { id: '2', type: trans('field.na') }, //para animales no sexados
          ]}
        />

        <CxInput xref={useRef(null)} label={trans('field.alert')} dbfield="n_animal.txAlert" maxLength={200} redtext="true" />
        <CxInput xref={useRef(null)} label={trans('field.reference')} dbfield="n_animal.txReference" maxLength={50} />
        <CxInput xref={rf_txNumber} label={trans('field.number')} dbfield="n_animal.txNumber" maxLength={30}
          placeholder={getStoreValueBo('StoreSession', 'boAutoNumFiles') ? 'AUTO' : ''}
          disabled={getStoreValueBo('StoreSession', 'boAutoNumFiles') && !storeClient.inAnimal}
        />
        <CxInput xref={useRef(null)} label={trans('field.chip')} dbfield="n_animal.txChip" maxLength={23} />
        <CxInput xref={useRef(null)} label={trans('field.passport')} dbfield="n_animal.txPassport" maxLength={30} />

        <CxButtonShowMore label={`[${trans('field.show_more').toUpperCase()}]`} style={{ margin: '4px 0 4px 0px' }} >
          <CxDate xref={rf_dtFrom} label={trans('field.from')} dbfield="n_animal.dtFrom" />
          <CxDate xref={rf_dtTo} label={trans('field.to')} dbfield="n_animal.dtTo" />
          <CxInput xref={useRef(null)} label={trans('field.reason')} dbfield="n_animal.txReason" maxLength={50} />
          <CxChooser xref={rf_txTypeAnimalCondition}
            label={trans('field.condition')}
            dbfield="t_animal_condition.txTypeAnimalCondition" dbfieldkey="n_animal.itAnimalCondition"
            table="t_animal_condition"
            col_id="itAnimalCondition"
            col_tx="txTypeAnimalCondition"
          />
          <CxState mode='checkbox' xref={useRef(null)} label={trans('field.reproduction')} dbfield="n_animal.boReproduction" />
          <CxState mode='checkbox' xref={useRef(null)} label={trans('field.pedigree')} dbfield="n_animal.boPedigree" />
          <CxState mode='checkbox' xref={useRef(null)} label={trans('field.sterilization')} dbfield="n_animal.boSterilization" />

          <CxInput xref={rf_txNumberAnimals} label={trans('field.number_animals')} dbfield="n_animal.txNumberAnimals" maxLength={10} />
          <CxInput xref={useRef(null)} label={trans('field.nature')} dbfield="n_animal.txNature" maxLength={50} />
          <CxInput xref={useRef(null)} label={trans('field.habitat')} dbfield="n_animal.txHabitat" maxLength={50} />
          <CxInput xref={useRef(null)} label={trans('field.feeding')} dbfield="n_animal.txFeeding" maxLength={50} />
          <CxChooser xref={rf_txTypeRate}
            label={trans('field.rate')}
            dbfield="t_rate.txTypeRate" dbfieldkey="n_animal.itRate"
            table="t_rate"
            col_id="itRate"
            col_tx="txTypeRate"
            filter={`t_rate.boActive='${'1'}'`}
          />
          <CxDate xref={useRef(null)} label={`${trans('field.rate')} ${trans('field.from')}`} dbfield={"n_animal.dtRateFrom"} />
          <CxDate xref={useRef(null)} label={`${trans('field.rate')} ${trans('field.to')}`} dbfield={"n_animal.dtRateTo"} />

          <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
            dbfield="n_employee.txEmployee" dbfieldkey="n_animal.inEmployee"
            url="employees" col_id="inEmployee" col_tx="txEmployee"
            tooltip={`${trans('field.employee')}`}
            columns={[
              { id: "0", Header: "ID", accessor: "inEmployee", show: false },
              { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
            ]}
          />
        </CxButtonShowMore>

        {isApp('vett') &&
          <CxAccordion xref={r_accordion_weight} storageKey={getAnimalAccordionStorageKey('weight')} title={trans('field.weight')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
            <CxTable
              xref={r_table_weight}
              margin="-15px 0px 0px 0px"
              url="animals/weight"
              filter={`inAnimal='${storeClient.inAnimal}'`}
              onOpenForm={openFormWeight}
              hasButtonAdd={true}
              columns={[
                { id: "0", Header: "ID", accessor: "inAnimalWeight", show: false },
                { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtWeight"]), width: '15%' },
                { id: "2", Header: trans('field.weight'), accessor: row => FxTable.cellTo2r00(row["nuWeight"]), width: '15%' },
                { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '70%', show: size.isLarge },
              ]}
            />
          </CxAccordion>
        }

        {isApp('vett') &&
          <CxAccordion xref={r_accordion_vaccs} storageKey={getAnimalAccordionStorageKey('vaccs')} title={trans('field.vaccs')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
            <CxTable
              xref={r_table_vaccs}
              margin="-15px 0px 0px 0px"
              url="vaccs"
              filter={`inAnimal='${storeClient.inAnimal}'`}
              onOpenForm={openFormVacc}
              hasButtonAdd={true}
              refColors={['table_cell_color_black|' + trans('field.pending')]}
              columns={[
                { id: "0", Header: "ID", accessor: "inVacc", show: false },
                { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '15%' },
                { id: "2", Header: trans('field.next'), accessor: row => FxTable.cellToLocalDate(row["dtNext"]), width: '15%', show: size.isLarge },
                { id: "3", Header: trans('field.ps'), accessor: "txPs", width: '35%' },
                { id: "4", Header: trans('field.remarks'), accessor: "txRemarks", width: '35%', show: size.isLarge },
                { id: "5", Header: trans('field.comm_s'), accessor: row => (row["hasComm"]==='1' ? trans('field.yes') : trans('field.no')), width: '5%', show: size.isLarge },
                { id: "A", Header: "not_pending", accessor: row => Boolean(row["_inVaccNextSimilar"]), show: false },
              ]}
            />
          </CxAccordion>
        }

        {isApp('vett') &&
          <CxAccordion xref={r_accordion_cnss} storageKey={getAnimalAccordionStorageKey('cnss')} title={trans('field.cnss')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
            <CxTable
              xref={r_table_cnss}
              margin="-15px 0px 0px 0px"
              url="cnss"
              filter={`n_cns.inAnimal='${storeClient.inAnimal}'`}
              onOpenForm={openFormCns}
              hasButtonAdd={true}
              buttonAddOptions={getCnsOptions()}
              refColors={['table_cell_black|' + trans('field.pending'), 'table_cell_color_green|' + trans('field.finished_1')]}
              columns={[
                { id: "0", Header: "ID", accessor: "inCns", show: false },
                { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDateTime(row["dtFrom"]), width: '15%' },
                { id: "2", Header: trans('field.type'), accessor: row => FxTable.replace(row["txType"], getCnsOptions()), width: '15%', show: size.isLarge },
                { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '35%' },
                { id: "4", Header: trans('field.notes'), accessor: "txNotes", width: '35%', show: size.isLarge },
                { id: "G", Header: "automatic", accessor: row => Boolean(row["itStatusCns"] === '000002.SRV'), show: false },
                {
                  id: "BTN_OPEN_IN_NEW_TAB",
                  Header: "",
                  accessor: row => <CxIconButtonNew
                    icon={<BiLinkExternal fontSize={20} />}
                    classType="ibs_iconbutton_table_body"
                    onClick={(event) => {
                      event.stopPropagation();
                      openCnsInNewTab(row);
                    }}
                    tooltip={trans('field.open_in_new_tab')}
                  />,
                  align: 'center',
                  width: '33px'
                },
              ]}
            />
          </CxAccordion>
        }

        {isApp('vett') &&
          <CxAccordion xref={r_accordion_rxs} storageKey={getAnimalAccordionStorageKey('rxs')} title={trans('field.rxs')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
            <CxTable
              xref={r_table_rxs}
              margin="-15px 0px 0px 0px"
              url="rx_auto"
              filter={`n_rx_auto.inAnimal='${storeClient.inAnimal}'`}
              onOpenForm={openFormRxs}
              hasButtonAdd={true}
              buttonAddOptions={[
                { id: 'M', text: trans('field.manual') },
                { id: 'A', text: trans('field.automatic_0') },
              ]}
              disabledUntilUpgrade={!FxEdition.isInEdition('CLI_rxs')}
              refColors={['table_cell_black|' + trans('field.manual'), 'table_cell_color_green|' + trans('field.automatic_0')]}
              columns={[
                /* { id: "inRxAuto", Header: "ID", accessor: "inRxAuto", show: false }, */
                { id: "dtRxAuto", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtRxAuto"]), width: '15%' },
                { id: "txRxAuto", Header: trans('field.rx'), accessor: "txRxAuto", width: '15%' },
                { id: "itSeriesRx", Header: "_itSeriesRx", accessor: "itSeriesRx", show: false }, 
                { id: "txPs", Header: trans('field.ps'), accessor: "txPs", width: '35%', show: size.isLarge },
                { id: "txNotes", Header: trans('field.notes'), accessor: "txNotes", width: '35%', show: size.isLarge },
                { id: "atb", Header: 'Atb', accessor: row => (row["isAntibiotic"]==='1' ? trans('field.yes') : trans('field.no')), width: '10%', show: size.isLarge && FxRegion.isSpain() },
                { id: "pvt", Header: 'PresVet', accessor: row => (row["isAntibiotic"]==='1' ? Boolean(FxStr.isNumeric(row["txCodePresvet"])) ? trans('field.yes') : trans('field.no'): ''), width: '10%', show: size.isLarge && FxRegion.isSpain() && !FxRegion.isAndalusia() },
                { id: "G", Header: "automatic", accessor: row => Boolean(row["inInvoice"]), show: false },
              ]}
            />
          </CxAccordion>
        }

        <CxAccordion xref={r_accordion_groo} storageKey={getAnimalAccordionStorageKey('grooming')} title={trans('field.grooming')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
          <CxTable
            xref={r_table_groo}
            margin="-15px 0px 0px 0px"
            url="groo"
            filter={`n_grooming.inAnimal='${storeClient.inAnimal}'`}
            onOpenForm={openFormGroo}
            hasButtonAdd={true}
            columns={[
              { id: "0", Header: "ID", accessor: "inGrooming", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDateTime(row["dtFrom"]), width: '15%' },
              { id: "2", Header: trans('field.groo_pickup'), accessor: row => FxTable.cellToLocalTime(row["dtTo"]), width: '15%', show: size.isLarge },
              { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '35%' },
              { id: "4", Header: trans('field.notes'), accessor: "txNotes", width: '35%', show: size.isLarge },
            ]}
          />
        </CxAccordion>

        {isApp('vett') && <CxAccordion xref={r_accordion_brdg} storageKey={getAnimalAccordionStorageKey('boarding')} title={trans('field.boarding')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
          <CxTable
            xref={r_table_brdg}
            margin="-15px 0px 0px 0px"
            url="brdg"
            filter={`n_boarding.inAnimal='${storeClient.inAnimal}'`}
            onOpenForm={openFormBrdg}
            hasButtonAdd={true}
            columns={[
              { id: "0", Header: "ID", accessor: "inBoarding", show: false },
              { id: "1", Header: trans('field.from'), accessor: row => FxTable.cellToLocalDateTime(row["dtFrom"]), width: '15%' },
              { id: "2", Header: trans('field.to'), accessor: row => FxTable.cellToLocalDate(row["dtTo"]), width: '15%', show: size.isLarge },
              { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '35%' },
              { id: "4", Header: trans('field.location'), accessor: "txTypeAnimalLocation", width: '35%', show: size.isLarge },
            ]}
          />
        </CxAccordion>}

        <CxAccordion xref={r_accordion_images} storageKey={getAnimalAccordionStorageKey('images')} title={trans('field.images')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
          <CxTable
            xref={r_table_images}
            margin="-15px 0px 0px 0px"
            url="images"
            filter={`n_image.inAnimal='${storeClient.inAnimal}' and n_image.txLinkImageId is null`}
            onOpenForm={openFormImage}
            hasButtonAdd={true}
            disabledUntilUpgrade={!FxEdition.isInEdition('CLI_img')}
            columns={[
              { id: "0", Header: "ID", accessor: "inImage", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '15%' },
              { id: "2", Header: trans('field.type'), accessor: "txTypeImage", width: '15%' },
              { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '72%' /* 2% adicional para alineación */, show: size.isLarge },
            ]}
          />
        </CxAccordion>

        <CxAccordion xref={r_accordion_multimedia} storageKey={getAnimalAccordionStorageKey('multimedia')} title={trans('field.multimedia_files')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
          <CxTable
            xref={r_table_multimedia}
            margin="-15px 0px 0px 0px"
            url="multimedia"
            filter={`n_multimedia.txLinkMultimediaTable='n_animal' and n_multimedia.txLinkMultimediaId='${storeClient.inAnimal}'`}
            onOpenForm={openFormMultimedia}
            hasButtonAdd={true}
            disabledUntilUpgrade={!FxEdition.isInEdition('CLI_mme')}
            columns={[
              { id: "0", Header: "ID", accessor: "inMultimedia", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtMultimedia"]), width: '15%' },
              { id: "2", Header: trans('field.type'), accessor: "txTypeMultimedia", width: '15%' },
              { id: "3", Header: trans('field.issue'), accessor: "txIssue", width: '72%' /* 2% adicional para alineación */, show: size.isLarge },
            ]}
          />
        </CxAccordion>

        <CxInput xref={useRef(null)} label={trans('field.notes')} dbfield="n_animal.txNotes" minRows={4} speech />

      </GxForm>

      <CxDlgTable
        xref={r_dlgtable_rxs_invoice}
        open={dlgRxsInvoice}
        onSelect={openFormRxsNewAuto}
        onClose={() => setDlgRxsInvoice(false)}
        url={'rx_auto/invoices'}
        filter={`n_invoice.inAnimal='${storeClient.inAnimal}'`}
        columns={[
          { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtInvoice"]), width: '50%' },
          { id: "2", Header: trans('field.invoice'), accessor: "txInvoice", width: '50%' },
        ]}
        title={trans('field.invoice')}
      />

      <CxDlgDoc xref={r_dlg_doc} inClient={storeClient.inClient} inAnimal={storeClient.inAnimal} txModule={'A'} />

      <MxTypeOTF xref={r_dlg_new_species}
        url="animals/species/otf"
        name='field.species'
        onOk={(itXXX, txTypeXXX) => {
          rf_txTypeAnimalSpecies.current.setKey(itXXX);
          rf_txTypeAnimalSpecies.current.setVal(txTypeXXX);
          rf_txTypeAnimalBreed.current.setFilter(`t_animal_breed.itAnimalSpecies='${itXXX}'`);
          rf_txTypeAnimalBreed.current.clear();
        }}
      />
      <MxTypeOTF xref={r_dlg_new_breed}
        url="animals/breed/otf"
        name='field.breed'
        parent={rf_txTypeAnimalSpecies}
        onOk={(itXXX, txTypeXXX) => {
          rf_txTypeAnimalBreed.current.setKey(itXXX);
          rf_txTypeAnimalBreed.current.setVal(txTypeXXX);
        }}
      />
      <MxTypeOTF xref={r_dlg_new_coat}
        url="animals/coat/otf"
        name='field.coat'
        onOk={(itXXX, txTypeXXX) => {
          rf_txTypeAnimalCoat.current.setKey(itXXX);
          rf_txTypeAnimalCoat.current.setVal(txTypeXXX);
        }}
      />

      <CxDialog title={trans('msg.ask_print_x', 'field.history')} open={dlgPrint} onCancel={() => setDlgPrint(false)} onOk={() => doPrintX()} height='350px'>
        <div style={{ width: 'var(--ibs_control_width_md)', display: 'flex', flexDirection: 'column', gap: 5 }}>
          <CxDate xref={rf_print_from} label={trans('field.from')} width='var(--ibs_control_width_md)' fromYear2000 required />
          <CxDate xref={rf_print_to} label={trans('field.to')} width='var(--ibs_control_width_md)' today required />
          <CxState mode='checkbox' xref={rf_print_preview}
            label={trans('field.preview')}
            width='var(--ibs_control_width_md)'
            value={localStorage.getItem('MxAnimalForm.boPreview') || '1'}
          />
          <CxState mode='checkbox' xref={rf_print_cert_sign}
            label={trans('field.certificate_based_signature')}
            width='var(--ibs_control_width_md)'
            value={'0'}
            onClick={(value) => { if (value === '1') {
              if (!FxEdition.isInEdition('XXX_sig')) {
                rf_print_cert_sign.current.setValBoolean(false);
                r_dlg_upgrade.current.setOpen(true);
              } else {
                Promise.all([FxCertificate.getCertEmployee()]).then((result) => {
                  let rv = result[0];
                  setCertificate(rv||{});
                  if (rv.error==='rv_no_session_employee') {
                    rf_print_cert_sign.current.setValBoolean(false);
                    r_snack_error.current.setValAndOpen(trans('msg.user_x_not_linked_to_employee', getStoreValue('StoreSession', 'txUser')));
                  }
                  if (rv.error==='rv_no_certificate_employee') {
                    rf_print_cert_sign.current.setValBoolean(false);
                    r_snack_error.current.setValAndOpen(`${trans('msg.missing_x', 'field.certificate')}: ${trans('field.settings')} > ${trans('field.options')} > ${trans('field.certificates')} > ${trans('field.employees')}`);
                  }
                });
              }
            }; }}
          />
        </div>
      </CxDialog>

      <CxDlgAlert xref={r_dlg_alert} />
      <CxDlgUpgrade xref={r_dlg_upgrade} />
      <GxPrint xref={r_print} />

      <GxDlgSelectClient xref={r_dlg_select_client} // change owner
        includeAnimal={false} 
        title={trans('msg.select_x', trans('field.new_1_x', 'field.owner'))} 
        onSelect={(row, intermediateValues) => {
          if (!row.original.inClient) {
            return;
          }
          let record = {};
          record['inAnimal'] = storeClient.inAnimal;
          record['inClient'] = row.original.inClient;
          FxLog.infox('MxAnimalForm.return.GxDlgSelectClient', '...row.original:', row.original);
          Promise.all([FxFetch.doJsonX("animals/change_animal_owner", record)]).then((result) => {
            if (result[0]) {
              storeClient.inClient = row.original.inClient;
              storeClient.txClient = row.original.txClient;
              Promise.all([setStoreClient(setStoreClient)]).then((result) => {
                rf_owner.current.setLabel(`${storeClient.txClient}`);
                r_snack_op_successful.current.setOpen(true);
                // 2024-10-16 - daq: para que si el usuario guarda, no vuelva a asignar al cliente viejo.
                rf_inClient.current.setVal(storeClient.inClient);
              });
            }
          });
        }} 
      />

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
      <CxSnackbar xref={r_snack_op_failed} severity="error" value={trans('msg.operation_failed')} />
      <CxSnackbar xref={r_snack_error} severity="error" />
      <CxSnackbar xref={r_snack_required} severity="error" />

      <GxPrintLong xref={r_gx_print_long} />
    </div>
  );

}

export default MxAnimalForm;
